'use strict';

import {applicationModel} from "../../models/applicationmodel.js";
import {evaluationModel} from "../../models/evaluationmodel.js";

export class ApplicationEvaluationCtrl
{
	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	item = {};
	evaltypes = {
		category_a: [],
		category_b: [],
		consolidate: [],
		confirmators: []
	};

	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.item = new applicationModel(jsDataService.get('applicationBase', {}), $filter, jsDataService);
		this.loadData();
	}

	loadData(){
		if(this.jsDataService.get('cfgDataUrl')){
			this.promise = this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgDataUrl'),
				method: 'GET',
				params: {}
			}).then((response) => {
				if(response.data.success){
					this.setData(response.data.data);
				}
			}, () => {});
		}
	}

	setData(data){
		this.evaltypes = {
			category_a: [],
			category_b: [],
			consolidate: [],
			confirmators: []
		};
		for(let row of data){
			if(typeof(this.evaltypes[row.category]) !== 'undefined'){
				this.evaltypes[row.category].push(new evaluationModel(row, this.$filter, this.jsDataService));
			}
		}
		console.log(this.evaltypes)
	}

	preview(ev, evaluation){
		if(typeof(evaluation.preview_url) !== 'undefined'){
			this.$scope.$root.goUrl(evaluation.preview_url);
		}
	}

	evaluate(ev, evaluation){
		if(typeof(evaluation.evaluate_url) !== 'undefined'){
			this.$scope.$root.goUrl(evaluation.evaluate_url);
		}
	}

	confirmComplete(ev, evaluation){
		if(typeof(evaluation.confirm_url) !== 'undefined'){
			this.$scope.$root.goUrl(evaluation.confirm_url);
		}
	}


}